import React, {useCallback, useEffect, useMemo, useState} from "react";
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {makeStyles} from "@material-ui/core/styles";
import QueryTable from "../../../../ui/QueryTable";
import useQuery from "../../../../ui/QueryTable/useQuery";
import SkillInfoDrawer from "../../../../Dict/Skills/Skill/components/SkillInfoDrawer";
import AddButton from "../../../../ui/AddButton";

const items = [
  {
    label: "Конструктор КиОП",
    link: "/work/app/constructor"
  },
  {
    label: "Конструктор компетенций",
    link: "#"
  }
];
const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});


const CompetenceList = (props) => {
  const [focusedCompetence, setFocusedCompetence] = useState(-1);
  const [selection, setSelection] = useState([]);
  const {root} = useStyles();
  const query = useQuery(5);

  useEffect(() => {
    query.load();
  }, []);

  const TableRowClick = useCallback((e) => {
    const focusedCompetence = e ? e.key : -1;
    setFocusedCompetence(focusedCompetence);
  }, [setFocusedCompetence]);

  const TableSelectionChanged = useCallback(e => {
    setSelection(e.selectedRowKeys || []);
  }, [setSelection]);

  const addCompetence = useCallback(() => {
    // TODO: Impl me
  }, []);

  const showDeleteModal = useCallback(() => {
    // TODO: Impl me
  }, []);

  const secondaryActions = useMemo(() => {
    return [
      {
        label: "Удалить выбранные",
        onClick: showDeleteModal,
        disabled: (!selection || selection.length === 0) //isDeletingSkill || selectedSkill.length === 0
      },
    ]
  }, [showDeleteModal, selection]);

  return (
    <div>
      <Breadcrumbs items={items}/>
      <div className={root}>
        <QueryTable
          focusedId={focusedCompetence}
          onSelectionChanged={TableSelectionChanged}
          onRowClick={TableRowClick}
          primaryActions={<AddButton onClick={addCompetence}/>}
          secondaryActions={secondaryActions}
          {...query} />
        <SkillInfoDrawer
          skillId={focusedCompetence}
          open={focusedCompetence !== -1}
        />
      </div>
    </div>
  );
};

export default CompetenceList;
